import { RuleStatus } from '@cbridge-tools/rules-data-grid';

export const getStatusFilterState = (added?: number, updated?: number, deleted?: number) => {
  return {
    [RuleStatus.Added]: { count: added ?? 0 },
    [RuleStatus.Updated]: { count: updated ?? 0 },
    [RuleStatus.Deleted]: { count: deleted ?? 0 },
  };
};
